import React from "react";

// Catches runtime render errors so the app never white-screens.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error caught by ErrorBoundary:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = "/homi";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-homi-light px-6 text-center">
          <div>
            <h1 className="font-heading font-extrabold text-3xl text-homi-black mb-3">Something went wrong</h1>
            <p className="text-homi-body mb-6">Please refresh the page — we'll have you back in no time.</p>
            <button
              onClick={this.handleReload}
              className="bg-homi-gold hover:bg-homi-goldDark text-homi-black font-heading font-bold px-6 py-3 rounded-lg transition-colors"
            >
              Back to Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
